import { render, staticRenderFns } from "./InvolvedPersonForm.vue?vue&type=template&id=28595d40&"
import script from "./InvolvedPersonForm.vue?vue&type=script&lang=js&"
export * from "./InvolvedPersonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports